import debounce from 'react-utils/debounce';
import { Alignments } from 'rich-text-lib/constants/alignments';
import { EmbedSizes, ResponsiveElligibleEmbeds } from 'rich-text-lib/constants/embed';
import { STYLE_OPTIONS, RESPONSIVE_EMBED_FULL_WIDTH_CLASS, hsmediaConfig, HS_EMBED_WRAPPER_CLASS } from '../constants/hsMedia';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../h... Remove this comment to see the full error message
import { isNestedOnlyChild } from '../hsformatting/utils';
import { trackInteraction } from './usageTracking';
import { EDIT_MEDIA_EMBED } from '../constants/usageTracking';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../h... Remove this comment to see the full error message
import { onSaveEmbed } from '../hsmedia/shared';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../h... Remove this comment to see the full error message
import { getEmbedPluginSetting } from '../hsmedia/util';
import { getMargins, getMaxDimensions, getAlignment } from './shared';
const isImg = target => {
  return target.tagName === 'IMG';
};
const EditTypes = {
  ALIGNMENT: 'alignment',
  DIMENSIONS: 'dimensions',
  FULL_WIDTH: 'fullwidth',
  MARGIN: 'margin',
  REMOVE: 'remove'
};
function _trackEmbedEdit(editor, editType) {
  trackInteraction(editor, 'tinymceEditEmbed', EDIT_MEDIA_EMBED, {
    editType,
    version: 'contextualToolbar'
  });
}
export const trackEmbedEdit = debounce(_trackEmbedEdit, 400);
const pixelOrNoUnitRegex = /^[0-9]+(?:px)?$/;
const getDimension = (editor, target, dimension) => {
  const value = editor.dom.getStyle(target, dimension);
  return value && pixelOrNoUnitRegex.test(value) ? parseInt(value, 10) : editor.dom.getSize(target)[dimension.includes('width') ? 'w' : 'h'];
};
export const getOnChangeAlignment = editor => (target, alignment = Alignments.NONE, oldAlignment) => {
  if (target.classList.contains('mce-preview-object') || target.classList.contains('hs-video') || target.classList.contains('mce-object') || target.classList.contains('hs-embeddable')) {
    editor.undoManager.transact(() => {
      if (editor.dom.hasClass(target, HS_EMBED_WRAPPER_CLASS) && !target.dataset.responsive) {
        // We need to set the width & height of the container in order for center
        // alignment to work properly since we don't already have the dimensions
        const width = getDimension(editor, target, 'width');
        const height = getDimension(editor, target, 'height');
        editor.dom.setStyles(target, {
          'max-width': `${width}px`,
          'max-height': `${height}px`,
          clear: 'both'
        });
      }
      if (alignment === oldAlignment) {
        alignment = Alignments.NONE;
      }
      const alignStyles = STYLE_OPTIONS[alignment];
      if (alignStyles) {
        editor.dom.setStyles(target, alignStyles);
      }
    });
    trackEmbedEdit(editor, EditTypes.ALIGNMENT);
  }
};
export const getDimensionsChangeHandler = editor => (target, dimensions) => {
  const {
    height,
    width
  } = dimensions;
  editor.undoManager.transact(() => {
    editor.fire('ObjectResized', {
      target,
      width,
      height
    });
  });
  trackEmbedEdit(editor, EditTypes.DIMENSIONS);
};
export const getUpdateMarginHandler = editor => (target, margin) => {
  const {
    top,
    left,
    right,
    bottom
  } = margin;
  editor.undoManager.transact(() => {
    editor.dom.setStyles(target, {
      'margin-top': top,
      'margin-left': left,
      'margin-right': right,
      'margin-bottom': bottom
    });
  });
  trackEmbedEdit(editor, EditTypes.MARGIN);
};
export const getSizeChangeHandler = editor => (target, size) => {
  editor.fire('hsEmbedSizeChange', {
    target,
    size
  });
  if (size === EmbedSizes.FULL) {
    trackEmbedEdit(editor, EditTypes.FULL_WIDTH);
  }
};
export const getEmbedSaveHandler = editor => (target, data) => onSaveEmbed(editor, target, data);
export const getEmbedOptions = (editor, target) => {
  const {
    dom,
    settings
  } = editor;
  let width;
  let height;
  let isFullWidth;
  let showResponsiveSizeOptions;
  let showDimensionsControls = true;
  const embedType = target.getAttribute('data-mce-object');
  if (editor.dom.hasClass(target, HS_EMBED_WRAPPER_CLASS)) {
    const responsive = !!target.dataset.responsive;
    const hasScripts = !!target.dataset.scriptEmbed;
    width = getDimension(editor, target, 'max-width');
    height = getDimension(editor, target, 'max-height');
    isFullWidth = dom.hasClass(target, RESPONSIVE_EMBED_FULL_WIDTH_CLASS);
    showResponsiveSizeOptions = responsive && !hasScripts;
    showDimensionsControls = responsive;
  } else if (dom.hasClass(target, 'hs-video')) {
    width = dom.getStyle(target, 'max-width') && parseInt(dom.getStyle(target, 'max-width'), 10);
    height = dom.getStyle(target, 'max-height') && parseInt(dom.getStyle(target, 'max-height'), 10);
  } else if (embedType === 'iframe' && settings.media_live_embeds) {
    const elems = dom.select('iframe', target);
    if (elems.length) {
      const iframe = elems[0];
      width = parseInt(iframe.getAttribute('width') || '0', 10);
      height = parseInt(iframe.getAttribute('height') || '0', 10);
      isFullWidth = dom.hasClass(iframe, RESPONSIVE_EMBED_FULL_WIDTH_CLASS);
      showResponsiveSizeOptions = ResponsiveElligibleEmbeds.includes(iframe.getAttribute('data-service') || '');
    }
  } else {
    width = getDimension(editor, target, 'width');
    height = getDimension(editor, target, 'height');
  }
  const options = {
    dimensions: {
      width,
      height
    },
    alignment: getAlignment(target),
    maxDimensions: getMaxDimensions(getEmbedPluginSetting(editor, hsmediaConfig.MAX_DIMENSION_WIDTH), width, height),
    margin: getMargins(editor, target),
    [`${Alignments.JUSTIFY}Disabled`]: !showResponsiveSizeOptions,
    showDimensionsControls: showDimensionsControls && !isFullWidth
  };
  if (isFullWidth) {
    // Use overridden iframe dimensions
    const iframeEl = dom.select('iframe', target)[0];
    const iframeWidth = iframeEl && dom.getAttrib(iframeEl, 'width');
    const iframeHeight = iframeEl && dom.getAttrib(iframeEl, 'height');
    options.dimensions = {
      width: iframeWidth || width,
      height: iframeHeight || height
    };
    options.alignment = Alignments.JUSTIFY;
  }
  return options;
};
export const isEditableEmbed = (editor, node) => {
  if (!node) return false;
  const {
    dom
  } = editor;
  if (dom.hasClass(node, 'hs-video')) {
    return false;
  }
  return editor.settings.media_live_embeds === true && dom.hasClass(node, 'mce-preview-object') || isImg(node) && dom.hasClass(node, 'mce-object') || dom.hasClass(node, 'hs-embeddable') || dom.hasClass(node, HS_EMBED_WRAPPER_CLASS);
};
export const getRemoveEmbedHandler = editor => target => {
  const dom = editor.dom;
  const parent = target.parentNode;
  const isOnlyChild = isNestedOnlyChild(target, target.parentNode);
  editor.undoManager.transact(() => {
    editor.selection.collapse();
    if (parent && isOnlyChild && ['P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'DIV', 'PRE'].includes(target.parentNode.nodeName)) {
      dom.remove(parent);
    } else {
      const bookmark = editor.selection.getBookmark();
      dom.remove(target);
      editor.selection.moveToBookmark(bookmark);
    }
  });
  trackEmbedEdit(editor, EditTypes.REMOVE);
};